import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/router'

//Store
import store from './store/index'

// VueThailandAddress
import 'vue-thailand-address/dist/vue-thailand-address.css';
import VueThailandAddress from 'vue-thailand-address';

Vue.use(VueThailandAddress);

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
